import axios, { AxiosError } from 'axios'
import { ElMessage } from 'element-plus'
import type { ApiErrorPayload } from '../types/api'

export const ACCESS_TOKEN_KEY = 'alarm-admin-access-token'
export const REFRESH_TOKEN_KEY = 'alarm-admin-refresh-token'

export const http = axios.create({
  baseURL: import.meta.env.VITE_API_BASE_URL ?? '/api/v1',
  timeout: 15_000,
})

http.interceptors.request.use((config) => {
  const token = localStorage.getItem(ACCESS_TOKEN_KEY)
  if (token) {
    config.headers.Authorization = `Bearer ${token}`
  }
  return config
})

http.interceptors.response.use(
  (response) => response,
  (error: AxiosError<ApiErrorPayload>) => {
    if (error.response?.status === 401) {
      localStorage.removeItem(ACCESS_TOKEN_KEY)
      localStorage.removeItem(REFRESH_TOKEN_KEY)
      if (window.location.pathname !== '/login') {
        window.location.assign('/login')
      }
    }

    const message = error.response?.data?.message ?? '请求失败，请稍后重试'
    ElMessage.error(message)
    return Promise.reject(error)
  },
)
